import { Button } from '@talentmesh/ui/components/button';
import { ChevronLeft } from 'lucide-react';
import { generatePath, useNavigate } from 'react-router';
import { useInvitationPageContext } from '../Contexts/InvitationPageContext';
import useCompanyId from '@/Hooks/UseCompanyId';
import RoutePath from '@/Routing/RoutePath';
import UIStrings from '@/Utils/UIStrings';

function BackButton() {
    const navigate = useNavigate();
    const companyId = useCompanyId();
    const { returnURL: from, clientId } = useInvitationPageContext();

    const handleOnClick = () => {
        const recruitmentOverviewPath = generatePath(RoutePath.AssessmentsActive, { companyId, clientId });
        const nextLocation = from || recruitmentOverviewPath;
        navigate(nextLocation);
    };

    return (
        <Button variant="ghost" size="sm" className="gap-1 px-0 pr-1" onClick={handleOnClick}>
            <ChevronLeft className="size-4" style={{ pointerEvents: 'auto' }} data-testid="ChevronLeftIcon" />
            {UIStrings.Back}
        </Button>
    );
}

export default BackButton;
